import React from "react";
import { NavLink } from "react-router-dom";

const Footer = () => {

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <>
            <div>
                {/*Start footer area */}
                <footer className="footer-area">
                    {/*Start Footer*/}
                    <div className="footer">
                        <div className="footer-bg" style={{ backgroundImage: 'url(assets/images/resources/footer-bg.png)' }} />
                        <div className="container">
                            <div className="row text-right-rtl">
                                {/*Start single footer widget*/}
                                <div className="col-12 col-sm-6 col-lg-3 wow animated fadeInUp" data-wow-delay="0.1s">
                                    <div className="single-footer-widget marbtm50">
                                        <div className="our-company-info">
                                            <div className="footer-logo">
                                                <NavLink to="/"><img src="assets/images/footer/footer-logo.svg" alt="" /></NavLink>
                                            </div>
                                            <div className="text-box">
                                                <p>Transforming visions into sustainable realities. Your trusted partner in construction consultancy and architecture services.</p>
                                            </div>
                                           
                                        </div>
                                    </div>
                                </div>
                                {/*End single footer widget*/}
                                {/*Start single footer widget*/}
                                <div className="col-12 col-sm-6 col-lg-3 wow animated fadeInUp" data-wow-delay="0.5s">
                                    <div className="single-footer-widget margin__top">
                                        <div className="title">
                                            <h3>Quick Links</h3>
                                        </div>
                                        <div className="footer-widget-links">
                                            <ul className="pull-left">
                                                <li><NavLink to="/About-Us">About</NavLink></li>
                                                {/* <li><NavLink to="/Services">Services</NavLink></li> */}
                                                <li><NavLink to="/Contact-Us">Contact Us</NavLink></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                {/*End single footer widget*/}
                                
                                {/*Start single footer widget*/}
                                <div className="col-12 col-sm-6 col-lg-3 wow animated fadeInUp" data-wow-delay="0.5s">
                                    <div className="single-footer-widget margin__top">
                                        <div className="title">
                                            <h3>Our Services</h3>
                                        </div>
                                        <div className="footer-widget-links">
                                            <ul className="pull-left">
                                                 <li><NavLink to="/Architecture">Architecture</NavLink></li>
                                                <li><NavLink to="/Building">Building</NavLink></li>
                                                <li><NavLink to="/Layout">Layout</NavLink></li>
                                                <li><NavLink to="/TDR">TDR</NavLink></li>
                                                <li><NavLink to="/BPS">BPS</NavLink></li>
                                                <li><NavLink to="/LRS">LRS</NavLink></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                {/*End single footer widget*/}
                                {/*Start single footer widget*/}
                                <div className="col-12 col-sm-6 col-lg-3 wow animated fadeInUp" data-wow-delay="0.3s">
                                    <div className="single-footer-widget margin__top marbtm50">
                                        <div className="title">
                                            <h3>Contact Us</h3>
                                        </div>
                                        <div className="footer-widget-contact-info">
                                            <ul>
                                                <li>
                                                    <div className="inner">
                                                        <div className="icon mapmarker">
                                                            <span className="flaticon-placeholder" />
                                                        </div>
                                                        <div className="text">
                                                            <p>24-6-674, OLD MILITARY COLONY, DHARGAMITTA, NELLORE, 524003.</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <div className="icon">
                                                            <span className="flaticon-phone" />
                                                        </div>
                                                        <div className="text">
                                                            <p><NavLink to="tel:9989574919">+91 9989574919</NavLink></p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <div className="icon">
                                                            <span className="flaticon-envelope-1" />
                                                        </div>
                                                        <div className="text">
                                                            <p><NavLink to="mailto:info@budplan.in">info@budplan.in</NavLink></p>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                {/*End single footer widget*/}
                                
                            </div>
                        </div>
                    </div>
                    {/*End Footer*/}
                    <div className="footer-bottom">
                        <div className="container">
                            <div className="bottom-inner">
                                <div className="copyright">
                                    <p>© 2026 BUDPLAN. All rights reserved.</p>
                                </div>
                                <div className="footer-social-link">
                                    <ul className="clearfix">
                                        <li><NavLink to="#"><i className="fa fa-facebook" aria-hidden="true" /></NavLink></li>
                                        <li><NavLink to="#"><i className="fa fa-twitter" aria-hidden="true" /></NavLink></li>
                                        <li><NavLink to="#"><i className="fa fa-google-plus" aria-hidden="true" /></NavLink></li>
                                        <li><NavLink to="#"><i className="fa fa-linkedin" aria-hidden="true" /></NavLink></li>
                                    </ul>
                                </div>
                                <div className="footer-menu">
                                    <ul className="footer-nav">
                                        <li><NavLink>Terms &amp; Conditions</NavLink></li>
                                        <li><NavLink>Privacy Policy</NavLink></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                {/*End footer area*/}

                <button className="scroll-top scroll-to-target" data-target="html" onClick={scrollToTop}>
                    <span className="icon-right-arrow-1" />
                </button>
                
               
            </div>

        </>
    )
}

export default Footer;